import React from 'react';

export const beneficiaryTitle = (
  groupText: string,
  programName: string,
  beneficiaryLabel?: string,
) => (
  <div>
    Select {groupText} of{' '}
    <b>
      {(beneficiaryLabel === 'Animals' ? 'People' : beneficiaryLabel) ||
        'Beneficiaries'}
    </b>{' '}
    that <b>{programName}</b> serves.
  </div>
);
